// src/features/dashboard/services/teamTableApi.ts

import api from '../../../api/apiService';

import {
  ENDPOINTS,
} from '../../../api/endpoints';

import type {
  EmployeeDayDetailsResponse,
} from '../types/activityDetails.types';

/**
 * =========================================
 * EMPLOYEE DAY DETAILS
 * =========================================
 */
export const getEmployeeDayDetails = async (
  employeeCode: string,
  loggedDate: string,
): Promise<EmployeeDayDetailsResponse> => {

  /**
   * FORMAT DATE
   */
  const formattedDate = loggedDate?.split('T')[0];

  console.log('API REQUEST', {
    employeeCode,
    loggedDate: formattedDate,
  });

  // Optional: verify token is available
  console.log(
    'Token:',
    localStorage.getItem('token'),
  );

const response = await api.post(
  ENDPOINTS.EMPLOYEE_DAY_DETAILS,
  {
    managerEmployeeCode: employeeCode,
    loggedDate: formattedDate,
  },
);

  console.log(
    'API RESPONSE',
    response.data,
  );

  return response.data;
};